import { z } from 'zod';

import {
  imageQuery,
  imageSchema,
  MediaItemSizeEnum,
} from '~/lib/api/fragments/image';

export const galleryMediaQuery = ({
  imageSize = 'MEDIUM_LARGE',
}: {
  imageSize: MediaItemSizeEnum;
}) => /* graphql */ `
  node {
    id
    mediaType
    mimeType
    altText
    sizes(size: ${imageSize})
    sourceUrl
    srcSet
    mediaItemUrl
    blurDataUrl

    mediaDetails {
      width
      height

      sizes {
        name
        width
        height
        mimeType
        sourceUrl
      }
    }

    featuredImage {
      ${imageQuery('MEDIUM')}
    }
  }
`;

export const galleryMediaSchema = z.object({
  node: z
    .object({
      id: z.string(),
      mimeType: z.string(),
      altText: z.string(),

      mediaDetails: z.object({
        width: z.number(),
        height: z.number(),

        sizes: z
          .array(
            z.object({
              name: z.union([
                z.literal('blur'),
                z.literal('thumbnail'),
                z.literal('medium'),
                z.literal('medium_large'),
                z.literal('large'),
                z.literal('1536x1536'),
                z.literal('2048x2048'),
              ]),

              width: z.coerce.number(),
              height: z.coerce.number(),

              mimeType: z.string(),
              sourceUrl: z.string(),
            })
          )
          .nullish(),
      }),

      featuredImage: imageSchema.nullish(),
    })
    .and(
      z.discriminatedUnion('mediaType', [
        z.object({
          mediaType: z.literal('image'),
          sizes: z.string(),
          sourceUrl: z.string(),
          srcSet: z.string(),
          blurDataUrl: z.string().nullish(),
        }),

        z.object({
          mediaType: z.literal('file'),
          mediaItemUrl: z.string(),
        }),
      ])
    ),
});

export type GalleryMediaSchema = z.infer<typeof galleryMediaSchema>;
